import React, { FC } from 'react';

import { AlbumDescriptionWithLinks } from './AlbumDescriptionWithLinks';
import { CustomLogo, MegaHeader, TopBar } from './CustomGridHeaderStyled';
import { Pictures } from '../../types';
import { getRawUploadedImageUrl } from '../../utils/helpers';

interface Props {
  customLogo: Pictures;
  webCustomLogo: boolean;
  description: string;
  name: string;
  isSearching: boolean;
}

const CustomGridHeader: FC<Props> = ({
  customLogo,
  webCustomLogo,
  description,
  name,
  isSearching = false,
}) => {
  const useCustomLogo = webCustomLogo && customLogo && customLogo.active;

  // Grab the logo's pure image path and then manipulate it below in the return
  const customLogoSrc = useCustomLogo && getRawUploadedImageUrl(customLogo);

  return (
    <TopBar isSearching={isSearching}>
      {customLogoSrc && (
        <CustomLogo>
          <img src={customLogoSrc} alt={name} />
        </CustomLogo>
      )}
      <MegaHeader style={{ margin: description ? '' : 0 }}>{name}</MegaHeader>
      {description && <AlbumDescriptionWithLinks>{description}</AlbumDescriptionWithLinks>}
    </TopBar>
  );
};

export default CustomGridHeader;
